var App = App || {};

App.Video = (() => {
    'use strict';

    const youtube = (source, title) => {
        return `<iframe src="${source}" title="${title}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
    };

    const vimeo = (source, title) => {
        return `<iframe src="${source}" title="${title}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
    };

    const stop = (videoElement) => {
        const target = videoElement.querySelector('.video__placeholder');
        const button = videoElement.querySelector('.video__button');

        if (target) {
            target.style.display = 'none';
            target.innerHTML = '';
        }
        if (button) {
            button.style.display = 'block';
        }
    };

    const play = (videoElement) => {
        document.querySelectorAll('.video').forEach(otherVideo => {
            if (otherVideo !== videoElement) {
                stop(otherVideo);
            }
        });

        const target = videoElement.querySelector('.video__placeholder');
        const button = videoElement.querySelector('.video__button');

        if (!target || !button) {
            console.error('Could not find video placeholder or button for playback.');
            return;
        }

        const source = button.dataset.src;
        const title = button.dataset.title;

        if (!source) {
            console.error('Video source (data-src) is missing from the video button.');
            return;
        }

        switch (true) {
            case source.toLowerCase().includes('youtube'):
                target.innerHTML = youtube(source, title || 'YouTube video player');
                break;
            case source.toLowerCase().includes('vimeo'):
                target.innerHTML = vimeo(source, title || 'Vimeo video player');
                break;
            default:
                console.log('Could not locate video content for source:', source);
        }

        button.style.display = 'none';
        target.style.display = 'block';
    };

    const init = (id) => {
        const widget = document.getElementById(id);
        const videoButton = widget.querySelector('.video__button');

        if (videoButton) {
            videoButton.addEventListener('click', () => {
                play(widget);
            });
        } else {
            console.warn('Video button not found for element:', widget);
        }

        const modal = widget.closest('.modal');
        if (modal) {
            modal.addEventListener('hidden.bs.modal', () => {
                stop(widget);
            });
        }
    };

    return {
        init: init
    };
})();
